import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/24x24/info.svg';
import { CodeEditor, FlexColumn } from '@elementary/common-ui/components';
import { Alert, Typography, styled } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';

const NOTE_TEXT =
  "Note: The query syntax is validated, however Elementary doesn't have access to your data and cannot execute the query on your behalf. It is recommended to run the query independently and review the results.";

const Header = styled(FlexColumn)`
  width: 100%;
  gap: 8px;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
};

const WizardQueryFormattingStage = ({ methods }: Props) => (
  <FlexColumn sx={{ p: 3, gap: 2, height: '100%' }}>
    <Header>
      <Typography sx={{ fontWeight: 'bold' }}>Create custom query</Typography>

      <Typography fontSize="14px">
        {`Write down a SELECT statement that returns the "failing" records - ones
        that disprove your assertion. The test will pass if the query returns
        zero records.`}
        <br />
        Please use the full table names (with database and schema names).
      </Typography>
    </Header>

    <Alert color="info" icon={<InfoIcon />}>
      {NOTE_TEXT}
    </Alert>

    <Controller
      name="customQuery"
      control={methods.control}
      render={({ field }) => <CodeEditor {...field} mode="sql" height="100%" />}
    />
  </FlexColumn>
);

export default WizardQueryFormattingStage;
